export enum KnownSegmentCategory {
  CONSUMER = "Consumer",
  DEMOGRAPHICS = "Demographics",
  HOUSEHOLD = "Household",
  AGE = "Age",
  CUSTOM = "Custom",
  GENDER = "Gender"
}
